import classNames from "classnames";
import { FC, ReactNode } from "react";
import Tag from "@Components/Decor/Tag";
import Chip from "@Components/Decor/Chip";
import { CorrectIcon } from "@Icons/MainIcons";
import BoltIcon from "@Icons/MainIcons/BoltIcon";

type BillCardProps = {
  title: ReactNode;
  subtitle: ReactNode;
  status: ReactNode;
  className?: string;
};

const BillCard: FC<BillCardProps> = ({ title, subtitle, status, className }) => {
  return (
    <div className={classNames("bg-background-default flex w-64 flex-col gap-4 rounded-lg p-5 shadow-lg", className)}>
      <Tag
        className="bg-transparent! p-0! shadow-none!"
        title={<span className="text-sm">{title}</span>}
        subtitle={subtitle}
        icon={<BoltIcon className="bg-background-primary h-full w-full rounded-full p-2 text-white" />}
      />
      <div className="flex flex-col gap-2">
        <div className="bg-background-subtle h-2 w-full rounded-full" />
        <div className="bg-background-subtle h-2 w-5/6 rounded-full" />
        <div className="bg-background-subtle h-2 w-2/3 rounded-full" />
      </div>
      <Chip
        title={status}
        icon={<CorrectIcon className="h-3 w-3" />}
        className="bg-background-success! text-font-success! px-2! text-xs! outline-none!"
      />
    </div>
  );
};

export default BillCard;
